export default __webpack_public_path__ + "static/media/checkmark.bb983143.svg";